import { HeartIcon } from '@heroicons/react/24/outline';
import React from 'react';

import { DiscriminatedProviderTreatmentStatusChangedEvent } from '@/services/api/generated/matterChangesService';

import {
  ActivityActions,
  ActivityBody,
  ActivityIcon,
  ActivityItem,
  ActivityLink,
  ActivityStatusTransition,
  ActivityTitle,
} from '../activity-feed-v2';
import { getUserFromEvent } from '../activity-feed-v2/ActivityDiffList';
import { formatStatus } from '../activity-feed-v2/utils';

export interface ProviderTreatmentStatusChangedEventProps {
  event: DiscriminatedProviderTreatmentStatusChangedEvent;
}

export const ProviderTreatmentStatusChangedEvent: React.FC<
  ProviderTreatmentStatusChangedEventProps
> = ({ event }) => {
  const { provider, old_treatment_status, new_treatment_status } =
    event.payload;
  const user = getUserFromEvent(event);

  const icon = (
    <ActivityIcon
      icon={
        <div className="flex h-6 w-6 items-center justify-center rounded-full bg-pink-100">
          <HeartIcon className="h-4 w-4 text-pink-600" />
        </div>
      }
    />
  );

  const body = (
    <ActivityBody>
      <div className="flex items-center gap-3">
        <ActivityTitle>{provider.name}</ActivityTitle>
        {old_treatment_status && new_treatment_status && (
          <ActivityStatusTransition
            from={formatStatus(old_treatment_status)}
            to={formatStatus(new_treatment_status)}
          />
        )}
      </div>
    </ActivityBody>
  );

  const actions = event.payload.target_id && (
    <ActivityActions>
      <ActivityLink
        href={`/matters/${event.matter_id}/treatment/${event.payload.target_id}`}
      >
        View Provider
      </ActivityLink>
    </ActivityActions>
  );

  return (
    <ActivityItem
      icon={icon}
      title="Treatment Status Changed"
      timestamp={new Date(event.occurred_at ?? new Date())}
      user={user}
      body={body}
      actions={actions}
    />
  );
};
